import React from 'react'
import style from './style'
import Header from '../Header'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import sortBy from 'ramda/src/sortBy'

const ListItem = ({ manufacturer, classes, search, selectedManufacturer, filterCameras, manufacturerSpecificCameraModels }) =>
    <div
      onClick={_ => {
        if (manufacturerSpecificCameraModels) return
        selectedManufacturer === manufacturer ? filterCameras({}, search, null, true) : filterCameras({}, search, manufacturer)
      }}
      className={selectedManufacturer === manufacturer ? classes.selected : classes.listItem}
    >
      <span className={classes.manufacturerName}>{manufacturer}</span>
      {
        manufacturer === 'Favorite' &&
        <FontAwesomeIcon icon='star' className={classes.star} />
      }
      {
        manufacturer === 'Recent' &&
        <FontAwesomeIcon icon='history' className={classes.clock} />
      }
    </div>

const ManufacturerList = props => {
  const { manufacturers, selectedManufacturer, classes } = props

  return (
    <div className={classes.ManufacturerList}>
      <Header title='Brands' />
      <div className={classes.list}>
        <ListItem {...props} manufacturer='Recent' key='Recent' />
        <ListItem {...props} manufacturer='Favorite' key='Favorite' />
        {
          manufacturers.map((m, i) => <ListItem {...props} manufacturer={m} key={m} />)
        }
        {
          props.manufacturerSpecificCameraModels &&
          <div
            className={classes.showOtherManufacturers}
            onClick={props.resetSpecificManufacturerAndRestartAppAction}
          >
            Show Other Manufacturers
          </div>
        }
      </div>
    </div>
  )
}

export default injectSheet(style)(ManufacturerList)



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/ManufacturerList/index.js